<template>
  <label for="touchnet-tax-exempt">{{
    t('sites.singleSite.financialConfig.mealPlans.form.tenders.taxExempt')
  }}</label>
  <SelectButtonField
    :id="`touchnet-tax-exempt`"
    :name="`${formNamespace}tax_exempt`"
    :options="taxExemptOptions"
    optionLabel="label"
    optionValue="value"
    :unselectable="false"
    :disabled="!editMealPlan"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useMealPlan } from '../../composables';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '../../../../../../routes';
import { inject } from 'vue';

// Set localization
const { t } = useI18n();

// Set meal plan composable
const { taxExemptOptions } = useMealPlan();

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);
const formNamespace = inject('formNamespace', '');
</script>
